export type TagScope = 'agency' | 'system'

export type TaggableType =
    | 'Client'
    | 'Employee'
    | 'Card'
    | 'Agency'
    | 'Organization'
    | 'User'

export interface Tag {
    id: string
    name: string
    scope: TagScope
    color?: string
    agencyId?: string
    createdById?: string
    details?: Record<string, any>
    createdAt?: string
    updatedAt?: string
}

export interface Tagging {
    id: string
    tagId: string
    taggableType: TaggableType
    taggableId: string
    createdAt?: string
}

export interface FetchTagsParams {
    scope?: TagScope
    agency_id?: string
}

export interface CreateTagParams {
    name: string
    scope: TagScope
    color?: string
    agency_id?: string
    details?: Record<string, any>
}

export interface UpdateTagParams {
    id: string
    name?: string
    color?: string
    details?: Record<string, any>
}

export interface AssignTagParams {
    tag_id: string
    taggable_type: TaggableType
    taggable_id: string
}

export interface UnassignTagParams {
    tag_id: string
    taggable_type: TaggableType
    taggable_id: string
}

export const TAG_COLORS: string[] = [
    '#ef4444',
    '#f97316',
    '#f59e0b',
    '#eab308',
    '#84cc16',
    '#22c55e',
    '#14b8a6',
    '#0ea5e9',
    '#3b82f6',
    '#8b5cf6',
    '#d946ef',
    '#64748b'
]

export interface EntityWithTags {
    id: string
    tags?: Tag[]
}

export const entityKey = (taggableType: TaggableType, taggableId: string): string =>
    `${taggableType}:${taggableId}`
